export default __webpack_public_path__ + "static/media/greenArrowDown.a473ae4e.svg";